// extracted by mini-css-extract-plugin
export var button = "_ls-2";
export var card = "_ls-0";
export var closeButtonContainer = "_ls-3";
export var iconContainer = "_ls-1";